var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card"},[_c('img',{attrs:{"src":"/img/camera.jpg","alt":"Camera"}}),_c('p',[_vm._v("New Camera")]),_c('p',{staticClass:"price"},[_vm._v("$100.00")]),_c('button',{attrs:{"id":"checkout-button"}},[_vm._v("Checkout")])])
}]

export { render, staticRenderFns }